import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=7f0c5732&scoped=true&"
import script from "./InfoModal.vue?vue&type=script&lang=ts&"
export * from "./InfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=7f0c5732&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0c5732",
  null
  
)

export default component.exports